<mat-table [dataSource]="dataSource" matSort matSortActive="to" matSortDirection="desc">
  <ng-container matColumnDef="memberName">
    <mat-header-cell i18n *matHeaderCellDef mat-sort-header>Mitglied</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.memberName }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="from">
    <mat-header-cell i18n *matHeaderCellDef mat-sort-header>Von</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.from | date: 'short' }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="to">
    <mat-header-cell i18n *matHeaderCellDef mat-sort-header>Bis</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.to | date: 'short' }} </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="['memberName', 'from', 'to']; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: ['memberName', 'from', 'to']"></mat-row>
</mat-table>
